import React from 'react';
import ViewSelectorContainer from './ViewSelectorContainer';
import { Box, Typography, useTheme } from '@mui/material';
import Compass from './Compass';
import Button from '@mui/material/Button';
import PanToolIcon from '@mui/icons-material/PanTool';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import useMediaQuery from '@mui/material/useMediaQuery';

export function ControlToolbar({
  angle,
  drag,
  setDrag,
  rotateLeft,
  rotateRight,
  zoomIn,
  zoomOut,
  isFullscreen,
  fullscreen,
}) {
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up('lg'));
  const md = useMediaQuery(theme.breakpoints.up('md'));

  const sx = {
    containerBorder: {
      borderRightStyle: 'dotted',
      borderRightWidth: '1px',
      borderRightColor: 'grey.500',
      paddingInline: '8px',
      display: 'flex',
      gap: '8px',
    },
    button: {
      minWidth: 'unset',
      padding: '6px',
      width: '34px',
      height: '34px',
      fontSize: '1rem',
    },
  };

  return (
    <ViewSelectorContainer
      className="palette-control-maquette"
      orientation="horizontal"
      sx={{
        paddingBlock: '6px',
        gap: 0,
        '> div:last-of-type': {
          border: 'none !important',
        },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          ...sx.containerBorder,
        }}
      >
        <Typography
          sx={{
            margin: 0,
            marginRight: '4px',
            fontFamily: 'font-family-dinCondensedBold',
          }}
        >
          Expo.
        </Typography>
        <Compass angle={angle} />
      </Box>

      {md && (
        <>
          <Box sx={{ ...sx.containerBorder }}>
            <Button
              variant="outlined"
              onClick={rotateLeft}
              sx={{ ...sx.button }}
            >
              <KeyboardArrowLeftIcon />
            </Button>

            <Button
              variant="outlined"
              onClick={rotateRight}
              sx={{ ...sx.button }}
            >
              <KeyboardArrowRightIcon />
            </Button>
          </Box>

          <Box sx={{ ...sx.containerBorder }}>
            <Button variant="outlined" onClick={zoomIn} sx={{ ...sx.button }}>
              <AddIcon />
            </Button>

            <Button variant="outlined" onClick={zoomOut} sx={{ ...sx.button }}>
              <RemoveIcon />
            </Button>
          </Box>
        </>
      )}

      {lg ? (
        <Box sx={{ ...sx.containerBorder }}>
          <Button
            variant={drag ? 'contained' : 'outlined'}
            onClick={() => setDrag(!drag)}
            sx={{ ...sx.button }}
          >
            <PanToolIcon />
          </Button>

          <Button variant="outlined" onClick={fullscreen} sx={{ ...sx.button }}>
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </Button>
        </Box>
      ) : null}
    </ViewSelectorContainer>
  );
}
